import React from "react";

export type PillCellRendererProps = {
    pillClass: string;
    text: string;
};

/**
 * Pure presentational React component that renders a pill used in grid cells.
 * Kept as a separate .tsx file for proper JSX parsing.
 */
const PillCellRenderer: React.FC<PillCellRendererProps> = ({
    pillClass,
    text,
}) => {
    const hasPill = typeof pillClass === "string" && pillClass.trim().length > 0;

    return (
        <div className="cell-pill-wrapper">
            {hasPill ? (
                <div className={pillClass}>
                    <span className="font-bold">{text}</span>
                </div>
            ) : (
                <div>
                    <span>{text}</span>
                </div>
            )}
        </div>
    );
};

export default PillCellRenderer;
export { PillCellRenderer };
